import { render } from "./main.vue?vue&type=template&id=635798d6&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=635798d6&lang=scss&scoped=true"

import exportComponent from "/Users/johnhan/Desktop/project/huitu_activity_fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635798d6"]])

export default __exports__